import styled from 'styled-components/macro';

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 90px;

  &::after {
    content: '';
    height: 100%;
    width: 72px;
    border-left: 1px solid #282324;
  }
`;

export default Footer;
